import React from "react";
import { IconProps } from "../Facebook/FacebookIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const YOUTUBE_BRAND = "#FF0000";

export const YoutubeIcon = (props: IconProps) => {
  const { className, size = "1x", color, active } = props;

  return (
    <FontAwesomeIcon
      style={{ color: color ?? (active === false ? "gray" : YOUTUBE_BRAND) }}
      icon={["fab", "youtube"]}
      className={className}
      size={size}
    />
  );
};
